import { useState, useEffect } from "react";

import { Link, NavLink, useLocation } from "react-router-dom";
import menus from "../../pages/menu";

import logo from "../../assets/images/logo/Jacob.png";

import "./styles.scss";

const Header = () => {
  const location = useLocation();
  const [menuActive, setMenuActive] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        // Adjust this value to control when the header transforms
        setScroll(true);
      } else {
        setScroll(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleMenuActive = () => {
    setMenuActive(!menuActive);
  };

  const handleDropdown = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <header id="header_main" className={`header ${scroll ? "is-fixed" : ""}`}>
      <div className="container big">
        <div className="row">
          <div className="col-11 mx-auto">
            <div className="header__body">
              <div className="header__logo">
                <Link to="/">
                  <img id="site-logo" src={logo} alt="logo" />
                </Link>
              </div>

              <div className="header__right">
                <div
                  className={`mobile-button ${menuActive ? "active" : ""}`}
                  onClick={handleMenuActive}
                >
                  <span></span>
                </div>
                <nav
                  id="main-nav"
                  className={`main-nav ${menuActive ? "active" : ""}`}
                >
                  <ul id="menu-primary-menu" className="menu">
                    {menus.map((data, idx) => (
                      <li
                        key={idx}
                        onClick={() => handleDropdown(idx)}
                        className={`menu-item ${
                          data.namesub ? "menu-item-has-children" : ""
                        } ${activeIndex === idx ? "active" : ""}`}
                      >
                        <Link to={data.links}>
                          <span>{data.name}</span>
                        </Link>
                        {data.namesub && (
                          <ul className="sub-menu">
                            {data.namesub.map((submenu) => (
                              <li key={submenu.id} className="menu-item">
                                <NavLink to={submenu.links}>
                                  {submenu.sub}
                                </NavLink>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    ))}
                  </ul>
                </nav>
              </div>

              <div className="header__action">
                <Link to="/" className={`header-link${location.pathname === "/" ? " active" : ""}`}>
                  Home
                </Link>
                <Link to="/about" className={`header-link${location.pathname === "/about" ? " active" : ""}`}>
                  About
                </Link>
                <Link to="/blog" className={`header-link${location.pathname === "/blog" ? " active" : ""}`}>
                  Blog
                </Link>
                <Link to="/contact" className="action-btn">
                  <span>Contact</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    // <header className={`header ${scroll ? 'is-fixed' : ''}`}>
    //         <div className="tf-container">
    //             <div className="row">
    //                 <div className="col-md-12">
    //                     <div id="site-header-inner">
    //                         <div id="site-logo" className="clearfix">
    //                             <div id="site-logo-inner">
    //                                 <Link to="/" rel="home" className="main-logo">
    //                                     <img id="logo_header" className='logo-dark' src='{logodark}' alt="Binasea" />
    //                                     <img id="logo_header" className='logo-light' src='{logo}' alt="Binasea" />
    //                                 </Link>
    //                             </div>
    //                         </div>

    //                        <div className="header-center">
    //                         <nav id="main-nav" className={`main-nav ${menuActive ? 'active' : ''}`}>
    //                             <ul id="menu-primary-menu" className="menu">
    //                                 {
    //                                     menus.map((data,idx) => (
    //                                         <li key={idx} onClick={()=> handleDropdown(idx)} className={`menu-item ${data.namesub ? 'menu-item-has-children' : ''} ${activeIndex === idx ? 'active' : ''}`}

    //                                         >
    //                                             <Link to={data.links}>{data.name}</Link>
    //                                             {
    //                                                 data.namesub &&
    //                                                 <ul className="sub-menu">
    //                                                     {
    //                                                         data.namesub.map((submenu) => (
    //                                                             <li key={submenu.id} className="menu-item"><NavLink to={submenu.links}>{submenu.sub}</NavLink></li>
    //                                                         ))
    //                                                     }
    //                                                 </ul>
    //                                             }

    //                                         </li>
    //                                     ))
    //                                 }
    //                             </ul>
    //                         </nav>
    //                        </div>

    //                         <div className="header-right">

    //                             <DarkMode />

    //                             <Link to="/contact" className="tf-button discord"><i className="icon-fl-vt"></i><span>DISCORD</span></Link>
    //                             <Link to="#" className="tf-button connect" data-toggle="modal" data-target="#popup_bid"> <i className="icon-fl-wallet"></i><span>CONNECT</span></Link>
    //                             <div className={`mobile-button ${menuActive ? 'active' : ''}`} onClick={handleMenuActive}><span></span></div>
    //                         </div>

    //                     </div>
    //                 </div>
    //             </div>
    //         </div>

    //     </header>
  );
};

export default Header;
